// eslint-disable-next-line 
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import createAppStore from './store/configureStore';
// Note: for the time being, not making use of the service worker
import { unregister } from './serviceWorker';
unregister();

// configure redux store
const store = createAppStore();

const domNode = document.getElementById('root');
const root = createRoot(domNode);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);